import { z } from "zod"

export const organizationSocialsSchema = z.object({
  socialMediaFacebook: z
    .string()
    .url("Must be a valid URL")
    .or(z.literal(""))
    .nullable(),
  socialMediaTwitter: z
    .string()
    .url("Must be a valid URL")
    .or(z.literal(""))
    .nullable(),
  socialMediaLinkedin: z
    .string()
    .url("Must be a valid URL")
    .or(z.literal(""))
    .nullable(),
  socialMediaInstagram: z
    .string()
    .url("Must be a valid URL")
    .or(z.literal(""))
    .nullable(),
})

export type OrganizationSocialsFormData = z.infer<
  typeof organizationSocialsSchema
>
